var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressMapTourFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6765 15.9519C18.9842 15.9519 17.6073 17.3107 17.6073 18.9808C17.6073 20.6509 18.9842 22.0096 20.6765 22.0096C22.3689 22.0096 23.7458 20.6509 23.7458 18.9808C23.7458 17.3107 22.3689 15.9519 20.6765 15.9519ZM20.6765 21C19.5483 21 18.6304 20.0942 18.6304 18.9808C18.6304 17.8674 19.5483 16.9616 20.6765 16.9616C21.8048 16.9616 22.7227 17.8674 22.7227 18.9808C22.7227 20.0942 21.8048 21 20.6765 21ZM20.6765 12.9231C17.2864 12.9231 14.5381 15.6352 14.5381 18.9808C14.5381 21.4232 15.4003 22.1053 20.0457 28.751C20.3505 29.1855 21.0026 29.1856 21.3074 28.751C25.9527 22.1053 26.815 21.4232 26.815 18.9808C26.815 15.6352 24.0667 12.9231 20.6765 12.9231ZM20.6765 27.8758C16.2231 21.5202 15.5612 21.0156 15.5612 18.9808C15.5612 17.6324 16.0933 16.3647 17.0594 15.4113C18.0256 14.4578 19.3102 13.9327 20.6765 13.9327C22.0429 13.9327 23.3275 14.4578 24.2937 15.4113C25.2598 16.3647 25.7919 17.6324 25.7919 18.9808C25.7919 21.0155 25.1304 21.5197 20.6765 27.8758Z",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressMapTourFailed);
export default __webpack_public_path__ + "static/media/address-map-tour-failed.fe78941d4cf5fe75ce28886b116b6c38.svg";
export { ForwardRef as ReactComponent };